import { lazy } from "react";
import { Image } from "lucide-react";
import type { AdminPlugin } from "@/plugins/types";

const GalleryManager = lazy(() => import("@/pages/admin/GalleryManager"));

const galleryPlugin: AdminPlugin = {
  id: "gallery",
  label: "Gallery",
  icon: Image,
  route: "gallery",
  component: GalleryManager,
  menuOrder: 2,
};

export default galleryPlugin;
